import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then((r) => navigate("/admin", { replace: true, state: { user: r.data } }))
      .catch((e) =>
        navigate("/admin/login", {
          replace: true,
          state: { error: formatApiError(e.response?.data?.detail) },
        })
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center" data-testid="auth-callback">
      <p className="font-serif text-2xl text-primary animate-pulse">Signing you in…</p>
    </div>
  );
}
